import { render, staticRenderFns } from "./RouteToAddress.vue?vue&type=template&id=2897d83f&"
import script from "./RouteToAddress.vue?vue&type=script&lang=js&"
export * from "./RouteToAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports